import {get} from '../utils'
import {getActiveChannel, isPublicChannel} from "../authentication/utils";
import localization from '../../../config/localization';

export default host => (clientId, query, channelId = null, target = "all") =>
  get(`${host}${isPublicChannel() ? "/public": ""}/clients/${clientId}/${!!channelId ? `channels/${channelId}/` : ""}user/globalSearch?q=${query}&target=${target}${getActiveChannel() ? `&cLang=${localization.getLanguage()}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)